<div class="otpmain-container" *ngIf="!showPasswordPopup">
  <div class="flex justify-content-start flex-wrap top-container">
    <div class="ml-4">
      <img src="assets/image/auto-e-care-logo.png" alt="Auto ECare" width="122" />
    </div>
  </div>

<div class="popup-container">
  <div class="popup-content">
    <h2>Verify Mobile Number</h2>
    <p class="description">
      Select your country code and enter your 10-digit phone number to receive a verification code.
    </p>

    <!-- Phone Number Input -->
    <div class="input-group">
      <!-- <label for="phoneNumber">Phone Number</label> -->
      <div class="phone-input-group">
        <!-- Country Code Dropdown -->
        <select id="countryCode" [(ngModel)]="model.countryCode" (change)="updateCountryId()"
          class="country-code-dropdown">
          <option *ngFor="let code of countryCodes" [value]="code.value">
            {{ code.label }}
          </option>
        </select>

        <!-- Phone Number Input -->
        <input pInputText class="p-inputtext" id="phoneNumber" type="tel" maxlength="10" [(ngModel)]="model.phoneNumber"
          (input)="handlePhoneNumberChange()" placeholder="Enter Phone Number" />
      </div>
    </div>

    <!-- Send OTP Button -->
    <div class="button-group">
      <button pButton *ngIf="!otpSent" type="button" class="btn-send-otp btn-primary" (click)="sendOtp()"
        [disabled]="!model.phoneNumber || model.phoneNumber.length !== 10 || !model.countryCode">
        Send OTP
      </button>
    </div>

    <!-- OTP Input -->
    <div *ngIf="otpSent && model.phoneNumber.length === 10" class="otp-input-container">
      <label for="otp">Enter OTP</label>
      <div class="otp-box-container">
        <p-inputOtp [length]="6" [disabled]="!otpSent" [(ngModel)]="model.otp"
          (ngModelChange)="onOtpChange($event)"></p-inputOtp>
      </div>
    </div>

    <!-- Verify Button -->
    <div *ngIf="otpSent && model.phoneNumber.length === 10" class="button-group">
      <button pButton type="button" class="btn-verify btn-primary" [disabled]="!otpSent || !isOtpValid()" (click)="onVerify()">
        Verify Account
      </button>
    </div>

    <!-- Resend Link -->
    <p *ngIf="otpSent" class="resend">
      <span *ngIf="resendTimer > 0">Resend OTP in {{ resendTimer }} secs</span>
      <a *ngIf="resendTimer === 0" (click)="resendOtp()">Resend</a>
    </p>
  </div>
</div>
<app-custom-toast></app-custom-toast>
</div>

<app-newpassword [visible]="showPasswordPopup" (onClose)="showPasswordPopup = false"></app-newpassword>


